import { getStorage } from '@src/utils/enhancedStorage'

import { LOCAL_STORAGE_KEYS } from './constants'
import isBrowser from './isBrowser'

const DISMISS_THRESHOLD = 3
const SUPPRESSION_WINDOW_MS = 7 * 24 * 60 * 60 * 1000

interface SuppressionState {
  dismissCount: number
  suppressedUntil: number | null
}

const readState = (): SuppressionState => {
  const raw = getStorage().getItemJSON<SuppressionState>(LOCAL_STORAGE_KEYS.WAITLIST.SMS_SUPPRESSION, {
    isGlobal: true,
  })
  if (!raw || typeof raw.dismissCount !== 'number') {
    return { dismissCount: 0, suppressedUntil: null }
  }
  return raw
}

const writeState = (state: SuppressionState): void => {
  getStorage().setItemJSON(LOCAL_STORAGE_KEYS.WAITLIST.SMS_SUPPRESSION, state, { isGlobal: true })
}

export const isWaitlistSmsModalSuppressed = (): boolean => {
  if (!isBrowser()) return false
  const state = readState()
  if (state.suppressedUntil == null) return false
  if (Date.now() < state.suppressedUntil) return true
  clearWaitlistSmsModalSuppression()
  return false
}

export const recordWaitlistSmsModalDismiss = (): void => {
  if (!isBrowser()) return
  const state = readState()
  if (state.suppressedUntil != null && Date.now() < state.suppressedUntil) return
  const nextCount = state.dismissCount + 1
  const next: SuppressionState =
    nextCount >= DISMISS_THRESHOLD
      ? { dismissCount: nextCount, suppressedUntil: Date.now() + SUPPRESSION_WINDOW_MS }
      : { dismissCount: nextCount, suppressedUntil: null }
  writeState(next)
}

export const clearWaitlistSmsModalSuppression = (): void => {
  if (!isBrowser()) return
  getStorage().removeItem(LOCAL_STORAGE_KEYS.WAITLIST.SMS_SUPPRESSION, { isGlobal: true })
}
